import React, {
    createContext,
    Dispatch,
    FC,
    ReactNode,
    Reducer,
    useContext,
    useReducer,
} from 'react'
import { combineReducers } from 'shared/utils/combineReducers'
import { DEFAULT_MS_STATE, MSAction, msReducer, MS_ACTIONS } from './msReducer'
import {
    DEFAULT_NONMS_STATE,
    nonMSReducer,
    NON_MS_ACTIONS,
} from './NonMasterSpec/nonMSReducer'
import { NonMSAction } from './NonMasterSpec/nonMSTypes'

export const [combinedReducer, initialPPLState] = combineReducers({
    nonMSProperties: [nonMSReducer, DEFAULT_NONMS_STATE],
    msProperties: [msReducer, DEFAULT_MS_STATE],
})

const PPLStateContext = createContext(initialPPLState)
const PPLDispatchContext = createContext({} as Dispatch<any>)

interface PPLContextInterface {
    children: ReactNode
    reducer: Reducer<
        Record<string, typeof DEFAULT_MS_STATE | typeof DEFAULT_NONMS_STATE>,
        NonMSAction | MSAction
    >
    initialState: Record<
        string,
        typeof DEFAULT_MS_STATE | typeof DEFAULT_NONMS_STATE
    >
}

// extracted this one for testability purposes
export const PPLContext: FC<PPLContextInterface> = ({
    children,
    reducer,
    initialState,
}) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <PPLDispatchContext.Provider value={dispatch}>
            <PPLStateContext.Provider value={state}>
                {children}
            </PPLStateContext.Provider>
        </PPLDispatchContext.Provider>
    )
}

const PPLProvider: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <PPLContext reducer={combinedReducer} initialState={initialPPLState}>
            {children}
        </PPLContext>
    )
}

export const PPL_ACTIONS = { ...MS_ACTIONS, ...NON_MS_ACTIONS }

export const usePPLContext = () => {
    const { msProperties, nonMSProperties } = useContext(PPLStateContext)

    const dispatch = useContext(PPLDispatchContext)
    return { msProperties, nonMSProperties, dispatch }
}

export default PPLProvider
